import { Config, IndexResult, Result } from "../types"
import _ from "underscore"
import ko from "knockout"
import $ from "jquery"
import { SearchBar } from "./SearchBar"

export class Page {
    visible: KnockoutObservable<boolean>
    loading: KnockoutObservable<boolean>
    searchQuery: KnockoutObservable<string>
    sendRequest: () => void
    xhr: JQueryXHR | null
    config: Config
    result: KnockoutObservable<Result | null>
    time: KnockoutObservable<number | null>
    activeIndex: KnockoutObservable<string>

    searchBarView: SearchBar

    constructor(config: Config) {
        this.config = config
        this.visible = ko.observable(false)
        this.loading = ko.observable(false)
        this.searchQuery = ko.observable("")
        this.activeIndex = ko.observable("magento_catalog_product")
        this.sendRequest = _.debounce(this.request, config.delay)
        this.xhr = null
        this.result = ko.observable(null)
        this.time = ko.observable(null)

        this.searchBarView = new SearchBar({
            query:   this.searchQuery,
            visible: this.visible,
        })


        this.visible.subscribe(visible => {
            $("html").toggleClass("mstInPage", visible)
        })

        $(document).on("keyup", e => {
            if (e.key === "Escape") {
                this.searchQuery() == "" && this.visible(false)
            }
        })

        this.searchQuery.subscribe(this.sendRequest)
    }

    selectIndex = (index: IndexResult) => {
        this.activeIndex(index.identifier)
    }

    request = () => {
        this.xhr?.abort()

        if (this.searchQuery() === "") {
            this.result(null)
            return
        }

        const ts = new Date().getTime()

        this.loading(true)

        this.xhr = $.ajax({
            url:      this.config.url,
            dataType: "json",
            type:     "GET",
            data:     {
                q:        this.searchQuery(),
                store_id: this.config.storeId,
                cat:      false,
                limit:    30,
                page:     1,
                buckets:  [ "category_ids" ],
                filters:  { "category_ids": 21 },
            },
            success:  (data: Result) => {
                this.loading(false)
                this.result(data)
                this.time((new Date().getTime() - ts) / 1000)
            },
        })
    }
}
